
      import '@folkjs/labs/standalone/folk-shape';

      const heightInput = document.querySelector('input[name="height"]');
      const widthInput = document.querySelector('input[name="width"]');

      function onHeightInput() {
        document.body.style.setProperty('--quantized-height', `${heightInput.value}px`);
      }

      heightInput.addEventListener('input', onHeightInput);

      function onWidthInput() {
        document.body.style.setProperty('--quantized-width', `${widthInput.value}px`);
      }

      widthInput.addEventListener('input', onWidthInput);

      onHeightInput();
      onWidthInput();
    